// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `li.top-login .uk-navbar-dropdown{padding-top:10px;cursor:default}li.top-login li.uk-nav-header{font-size:.7rem;padding-bottom:5px;margin-bottom:10px;border-bottom:1px solid #0000001a}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
